export function playSound(url) {
	const audio = new Audio(url);
	audio.volume = 0.2;
	audio.play().then();
}